import { fetchAuthSession } from 'aws-amplify/auth';
import QuinceError from '../error/quince-error.js';

const makeAuthData = ()=>{
    let loggedIn = false;
    let initialized = false;
    return Object.freeze({
        isLoggedIn: ()=>loggedIn,
        isInitialized: ()=>initialized,
        initialize: (isLoggedIn)=>{
            initialized = true;
            loggedIn = isLoggedIn;
        }
    });
};
const authData = makeAuthData();
const fetchAuthDetails = async ()=>{
    if (authData.isInitialized() && !authData.isLoggedIn()) return {
        isLoggedIn: false
    };
    try {
        const [session] = await Promise.all([
            fetchAuthSession()
        ]);
        const internalCustomerId = session.tokens?.idToken?.payload?.['custom:customer_id'] || null;
        const accessToken = session.tokens?.idToken?.toString();
        if (!internalCustomerId) {
            new QuinceError({
                name: 'InternalCustomerId not found',
                message: 'no internalCustomerId at fetchAuthDetails'
            });
            authData.initialize(false);
            return {
                isLoggedIn: false
            };
        }
        if (!accessToken) {
            new QuinceError({
                name: 'Access token not found',
                message: 'access token not found  at fetchAuthDetails'
            });
            authData.initialize(false);
            return {
                isLoggedIn: false
            };
        }
        authData.initialize(true);
        return {
            internalCustomerId,
            accessToken,
            isLoggedIn: true
        };
    } catch (error) {
        if (error.name !== 'NotAuthorizedException') {
            new QuinceError({
                name: 'Error while fetching AuthDetails',
                message: 'Error while fetching AuthDetails',
                data: {
                    error
                }
            }).capture();
        }
    }
    authData.initialize(false);
    return {
        isLoggedIn: false
    };
};
const makeDeferredPromise = ()=>{
    let resolve = ()=>{}, reject = ()=>{};
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    return {
        promise,
        resolve,
        reject
    };
};
let oneAuthCallInProgress = Promise.resolve();
const getAuthToken = async ()=>{
    await oneAuthCallInProgress;
    const deferredPromise = makeDeferredPromise();
    oneAuthCallInProgress = deferredPromise.promise;
    const authDetails = await fetchAuthDetails();
    deferredPromise.resolve();
    if (authDetails.isLoggedIn) {
        return `Bearer ${authDetails.accessToken}`;
    }
};

export { fetchAuthDetails, getAuthToken };
//# sourceMappingURL=auth.helpers.js.map
